<template>
  <Modal class="modalClass" v-model="showDialogData" :mask-closable="false" closable :styles="{top: '50px'}"
         width="700" :scrollable="false" @on-cancel="closeModal">
    <div class="title">预约产品演示</div>
    <div class="desc">请留下您的联系方式，我们会尽快与您安排产品演示</div>
    <div class="fromClass">
      <div class="itemClass">
        <div class="labelClass">姓名</div>
        <Input class="inputClass" v-model="fromObj.name" placeholder="请输入您的姓名"/>
      </div>
      <div class="itemClass">
        <div class="labelClass">性别</div>
        <RadioGroup class="radiusClass" v-model="fromObj.sex">
          <Radio label="1">男</Radio>
          <Radio label="2">女</Radio>
        </RadioGroup>
      </div>
      <div class="itemClass">
        <div class="labelClass">手机</div>
        <Input class="inputClass" v-model="fromObj.phone" placeholder="请输入您的手机号码"/>
      </div>
      <div class="itemClass">
        <div class="labelClass">公司名称</div>
        <Input class="inputClass" v-model="fromObj.companyName" placeholder="请输入您的公司名称"/>
      </div>
      <div class="itemClass">
        <div class="labelClass">需求描述</div>
        <Input class="inputClass -type-textarea" type="textarea" v-model="fromObj.demandDesc"
               placeholder="请描述您的需求，我们将为您推荐最合适的产品服务(如车队管理平台试 用需求)"/>
      </div>
    </div>
    <div slot="footer">
      <Button type="error" size="large" class="footerBut" long :loading="modal_loading" @click="add">立即预约</Button>
    </div>
  </Modal>
</template>
<script>
export default {
  props: {
    showDialogData: Boolean,
    closeModal: Function,
    fromObj: Object,
    modal_loading: Boolean,
    add: Function
  }
}
</script>
<style lang="scss" scoped>
.modalClass {
  .footerBut {
    background: #4c61d8;
    box-shadow: 0px 3px 10px 0px rgba(76, 97, 216, 0.25);
    border: 0;
    border-radius: 0;
    height: 50px;
    margin-bottom: 35px;
  }

  > > > .ivu-modal-footer {
    border: 0;
  }

  > > > .ivu-modal-content {
    padding: 0 20px;
    border-radius: 0 !important;
  }

  .fromClass {
    margin-top: 20px;


    .itemClass {
      margin-bottom: 20px;

      .radiusClass {
        margin-top: 12px;
      }
    }

    .-type-textarea > > > .ivu-input {
      height: 120px !important;
    }

    .inputClass {
      margin-top: 12px;

      > > > .ivu-input {
        height: 48px;
        background-color: #F4F4F4;
        font-size: 18px;
        font-weight: normal;
        border-radius: 0;
      }
    }

    .labelClass {
      font-size: 18px;
      font-weight: normal;
      color: #666;
    }
  }

  .desc {
    font-size: 20px;
    font-weight: normal;
    color: #999;
    margin-top: 5px;
  }

  .title {
    font-size: 34px;
    font-weight: 800;
    color: #333;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/header/cpyyModal.vue